import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import axios from 'axios'
// nodejs library that concatenates classes
import classnames from 'classnames'
// reactstrap components
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from 'reactstrap'
// core components
import AuthHeader from 'components/Headers/AuthHeader.js'
import { useDispatch } from 'react-redux'
import { userLogin } from 'store/user/actions'
import AxiosInstance from 'utils/AxiosInstance'

const Login = () => {
  const [focusedEmail, setfocusedEmail] = useState(false)
  const [focusedPassword, setfocusedPassword] = useState(false)

  //dev.admin@startkiwi.com
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const history = useHistory()
  const dispatch = useDispatch()

  const handleLogin = (e) => {
    e.preventDefault()

    const data = { email, password }

    AxiosInstance.post('/authenticate', data)
      .then((res) => {
        if (res && res.token) {
          localStorage.setItem('token', res.token)
          dispatch(
            userLogin(() => {
              if (res.reset) {
                history.push('/auth/first-login')
              } else {
                history.push('/dashboard')
              }
            })
          )
        } else {
          localStorage.removeItem('token')
          alert('invalid login')
        }
      })
      .catch((e) => console.log(e))
  }

  return (
    <>
      <AuthHeader title='Welcome!' lead='To Kiwi learning management system!' />
      <Container className='mt--8	'>
        <Row className='justify-content-center'>
          <Col lg='5' xl='5' xxl='6' md='7'>
            <Card className='bg-secondary border-0 mb-3 py-lg-4 py-xxl-5 px-xl-4'>
              <CardBody>
                <div className='text-center text-muted mb-5'>
                  <h1>Welcome</h1>
                  <small>Sign in with email or username</small>
                </div>
                <Form role='form' onSubmit={handleLogin} data-cy='login-form'>
                  <FormGroup
                    className={classnames('mb-3 w-100 m-0', {
                      focused: focusedEmail,
                    })}
                  >
                    <InputGroup className='input-group-merge input-group-alternative shadow-none'>
                      <InputGroupAddon addonType='prepend'>
                        <InputGroupText>
                          <i className='ni ni-email-83' />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        data-cy='email'
                        placeholder='Email'
                        type='email'
                        defaultValue={email}
                        onChange={(e) => setEmail(e.target.value)}
                        onFocus={() => setfocusedEmail(true)}
                        onBlur={() => setfocusedEmail(false)}
                      />
                    </InputGroup>
                  </FormGroup>
                  <FormGroup
                    className={classnames('w-100 m-0', {
                      focused: focusedPassword,
                    })}
                  >
                    <InputGroup className='input-group-merge input-group-alternative shadow-none'>
                      <InputGroupAddon addonType='prepend'>
                        <InputGroupText>
                          <i className='ni ni-lock-circle-open' />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        data-cy='password'
                        placeholder='Password'
                        type='password'
                        defaultValue={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onFocus={() => setfocusedPassword(true)}
                        onBlur={() => setfocusedPassword(false)}
                      />
                    </InputGroup>
                  </FormGroup>
                  <div className='text-center mt-5'>
                    <Button
                      className='btn-block'
                      color='info'
                      type='submit'
                      data-cy='submit'
                      style={{ backgroundColor: '#01A0F2' }}
                    >
                      Log in
                    </Button>
                  </div>
                  <Row className='mt-3 text-center'>
                    <Col>
                      <Link to='/auth/forgot-password'>
                        <small className='text-primary'>Forgot password?</small>
                      </Link>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Login
